export type NumberScale = null | 'K' | 'M' | 'B';

export function getNumberScale(value: number): NumberScale {
  if (value < 1e3) return null;
  if (value < 1e6) return 'K';
  if (value < 1e9) return 'M';
  return 'B'; // fallback
}

export function divideByScale(value: number, scale: NumberScale) {
  switch (scale) {
    case null:
      return value;
    case 'K':
      return value / 1e3;
    case 'M':
      return value / 1e6;
    case 'B':
      return value / 1e9;
  }
}
